/**
 * @generated SignedSource<<24b42bd10472a919ace32495e12b3385>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MyBuilds_viewer$data = {
  readonly user: {
    readonly builds?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"build_build">;
        } | null;
      } | null> | null;
    } | null;
    readonly id: string;
    readonly runningBuilds?: {
      readonly count: number;
    } | null;
    readonly scheduledBuilds?: {
      readonly count: number;
    } | null;
  } | null;
  readonly " $fragmentType": "MyBuilds_viewer";
};
export type MyBuilds_viewer$key = {
  readonly " $data"?: MyBuilds_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MyBuilds_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeBuildCounts"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeBuilds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyBuilds_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "condition": "includeBuilds",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 5
                }
              ],
              "concreteType": "BuildConnection",
              "kind": "LinkedField",
              "name": "builds",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BuildEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Build",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "build_build"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "builds(first:5)"
            }
          ]
        },
        {
          "condition": "includeBuildCounts",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "runningBuilds",
              "args": [
                {
                  "kind": "Literal",
                  "name": "state",
                  "value": [
                    "RUNNING",
                    "FAILING"
                  ]
                }
              ],
              "concreteType": "BuildConnection",
              "kind": "LinkedField",
              "name": "builds",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": "builds(state:[\"RUNNING\",\"FAILING\"])"
            },
            {
              "alias": "scheduledBuilds",
              "args": [
                {
                  "kind": "Literal",
                  "name": "state",
                  "value": "SCHEDULED"
                }
              ],
              "concreteType": "BuildConnection",
              "kind": "LinkedField",
              "name": "builds",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": "builds(state:\"SCHEDULED\")"
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "2b465ab87a77bc58f8eda3bdd818038f";

export default node;
